import * as React from 'react'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import Button from 'components/Button'

export interface IFlowInfoProps {
  showFlowCreateModal: any
  flowId?: string
  service: {
    id: string
    number: string
  }
}

export const FlowInfo = ({ flowId, service, showFlowCreateModal }: IFlowInfoProps) => (
  <div className={sMarg.mb30}>
    <div className={sText.lineTitle}>Linked Flow</div>
    {flowId ? (
      <div>
        <div className={sText.descrip3}>This number is linked to 1 flow.</div>
        <Button size="xs" to={`/dashboard/flows/${flowId}`} className={sMarg.mt15} color="tertiary">
          Edit Flow
        </Button>
      </div>
    ) : (
      <div>
        <div className={sText.descrip3}>
          There is no flow linked to this service. Add an 'Auto Responder' flow to automatically
          respond to incoming SMS messages.
        </div>
        <Button
          onClick={() => showFlowCreateModal({ service, showType: 'sms' })}
          className={sMarg.mt15}
          size="xs"
          color="tertiary"
        >
          Create Flow
        </Button>
      </div>
    )}
  </div>
)



// WEBPACK FOOTER //
// src/pages/MessageThread/FlowInfo.tsx